import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../../axios';
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  TextField,
  MenuItem,
  Button,
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

export default function InventoryReport() {
  const companyId = parseInt(localStorage.getItem('companyId'), 10);
  const [branches, setBranches] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [branchId, setBranchId] = useState('');
  const [stockId, setStockId] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`/Branch/by-company/${companyId}`).then(r => setBranches(r.data));
    axios.get(`/Stock/by-company/${companyId}`).then(r => setStocks(r.data));
  }, [companyId]);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        ...(branchId && { branchId }),
        ...(stockId && { stockId }),
      };
      const res = await axios.get(
        `/StockMovements/inventory-report/${companyId}`,
        { params }
      );
      const data = res.data.map((r, i) => ({
        id: i,
        productName: r.productName || r.ProductName,
        stockName: r.stockName || r.StockName,
        branchName: r.branchName || r.BranchName,
        totalIn: r.totalIn ?? r.TotalIn,
        totalOut: r.totalOut ?? r.TotalOut,
        closingStock: r.closingStock ?? r.ClosingStock,
      }));
      setRows(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, branchId, stockId]);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);
  const columns = [
    { field: 'productName', headerName: 'الصنف', flex: 1, width: 250, align: 'center', headerAlign: 'center' },
    { field: 'stockName',   headerName: 'المستودع', flex: 1, width: 150, align: 'center', headerAlign: 'center' },
    { field: 'branchName',  headerName: 'الفرع',    flex: 1, width: 150, align: 'center', headerAlign: 'center' },
    { field: 'totalIn',     headerName: 'الوارد',    type: 'number', width: 120, align: 'center', headerAlign: 'center' },
    { field: 'totalOut',    headerName: 'الصادر',    type: 'number', width: 120, align: 'center', headerAlign: 'center' },
    { field: 'closingStock',headerName: 'الرصيد',    type: 'number', width: 120, align: 'center', headerAlign: 'center' },
  ];

  return (
    <Container maxWidth="xl" dir="rtl" sx={{ py: 4 }}>
      <Card>
        <CardHeader
          title={<Typography variant="h6" align="center">تقرير جرد المخزون</Typography>}
        />
        <CardContent>
          <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
            <TextField
              select
              label="اختر فرعًا"
              size="small"
              value={branchId}
              onChange={e => setBranchId(e.target.value)}
              sx={{ width: 200 }}
            >
              <MenuItem value="">كل الفروع</MenuItem>
              {branches.map(b => (
                <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
              ))}
            </TextField>
            <TextField
              select
              label="اختر مستودعًا"
              size="small"
              value={stockId}
              onChange={e => setStockId(e.target.value)}
              sx={{ width: 200 }}
            >
              <MenuItem value="">كل المستودعات</MenuItem>
              {stocks.map(s => (
                <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
              ))}
            </TextField>
            <Button variant="contained" onClick={fetchReport}>تحديث</Button>
          </Box>
          <DataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            autoHeight
            components={{ Toolbar: GridToolbar }}
            pageSize={25}
            rowsPerPageOptions={[25, 50, 100]}
          />
        </CardContent>
      </Card>
    </Container>
  );
}